<div class="page-container" *ngIf="powerConfig$ | async as powerConfig">
  <h1>Auftrag zum Einbau eines intelligenten Messsystems / Smart-Meters</h1>
  <app-hint-card
    *ngIf="'commissioning.external.imsysInstallation.pageHint' | uiAdaptionVisible$ | async"
    [outlined]="true"
    [type]="'info'">
    <h2 style="color: inherit">Ihr Netzbetreiber möchte Ihnen folgende Informationen zum Antrag mitteilen</h2>
    <div
      [innerHTML]="
        'commissioning.external.imsysInstallation.pageHint' | uiAdaptionValue | safeHtmlPipe
      "></div>
  </app-hint-card>
  <div *ngIf="imSysForm$ | async as imSysForm; else loading">
    Mit * markierte Felder sind Pflichtfelder!
    <form style="padding-bottom: 2em" [formGroup]="imSysForm" formFocusable>
      <mat-vertical-stepper [linear]="true">
        <!-- Step -->
        <mat-step [stepControl]="imSysForm.controls.connectionObjectValid">
          <ng-template matStepLabel>Anschlussobjekt</ng-template>
          <section>
            <app-select-gis-data
              [areaType]="AreaTypeEnum.POWER"
              [disable]="false"
              [inputForm]="imSysForm"
              [inputFormAdditionalInfo]="null"
              [listDevelopmentAreas]="[]"
              [selectedGisData]="selectedConnectionObject$ | async"
              [companyLocationsBytenant]="companyLocationsByTenant$ | async"
              [eventsFromParent]="eventsFromParent$"
              (onSelectedGisData)="onGisDataChanged($event, imSysForm.controls.connectionObjectValid)" />
          </section>
          <div>
            <button mat-button matStepperNext type="button">Weiter</button>
          </div>
        </mat-step>

        <!-- Step -->
        <mat-step errorMessage="Bitte beheben Sie die Fehler" [stepControl]="imSysForm.controls.customer">
          <ng-template matStepLabel>Vertragsnehmer</ng-template>
          <section>
            <app-filiation-form
              [inputFormArray]="imSysForm.controls.customer"
              [id]="null"
              [selectedGisData]="selectedConnectionObject$ | async"
              [disableContractPartner]="true"></app-filiation-form>
          </section>

          <div>
            <button mat-button matStepperPrevious type="button">Zurück</button>
            <button mat-button matStepperNext type="button">Weiter</button>
          </div>
        </mat-step>

        <!-- Step  -->
        <mat-step [stepControl]="imSysForm.controls.technicalData">
          <ng-template matStepLabel>Weitere Informationen zum Netzanschluss</ng-template>
          <section>
            <form-row *ngIf="!isFieldHidden(powerConfig.externalImsysInstallationMeterNumberField)">
              <mat-form-field appearance="outline" fxFlex="95" style="padding-top: 5px">
                <mat-label>Zählernummer</mat-label>
                <input
                  matInput
                  type="text"
                  maxlength="90"
                  [formControl]="imSysForm.controls.technicalData.controls.meterNumber" />
                <mat-error
                  *ngIf="
                    imSysForm.controls.technicalData.controls.meterNumber.touched &&
                    imSysForm.controls.technicalData.controls.meterNumber.errors?.required
                  ">
                  Bitte geben Sie Ihre Zählernummer an
                </mat-error>
              </mat-form-field>
            </form-row>
            <form-row *ngIf="!isFieldHidden(powerConfig.externalImsysInstallationDeviceTypeField)">
              <mat-form-field appearance="outline" fxFlex="95">
                <mat-label>Angabe zur Zählerart</mat-label>
                <mat-select [formControl]="imSysForm.controls.technicalData.controls.deviceType">
                  <mat-option *ngFor="let option of deviceTypeOptions" [value]="option">
                    {{ option }}-Zähler
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    imSysForm.controls.technicalData.controls.deviceType.touched &&
                    imSysForm.controls.technicalData.controls.deviceType.errors?.required
                  ">
                  Bitte geben Sie Ihre Zählerart an
                </mat-error>
              </mat-form-field>
            </form-row>
            <app-upload-documents
              *ngIf="!isFieldHidden(powerConfig.externalImsysInstallationUploadsField)"
              [inputFormArray]="imSysForm.controls.technicalData.controls.uploads"
              [documentTag]="DocumentTagEnum.gridRegistrationDoc"
              [showTag]="false"
              [canUpdate]="true"
              [filterCriteria]="'equal'"
              [numberOfUploads]="10"
              [editUpload]="true"
              [showUploadButton]="true"
              [validFormats]="['.pdf', '.jpg', '.png', 'jpeg']">
              <p>
                Zählerschrank
                <br />
                Bitte laden Sie ein aktuelles Foto des geöffneten Zählerschrankes hoch. Achten Sie darauf,
                dass alle relevanten Komponenten gut sichtbar sind (z.B. Zähler, Sicherungen, Klemmen).
                (Erlaubte Dokumentenformate: ".pdf", ".png", ".jpg", "jpeg")
                <br />
              </p>
            </app-upload-documents>
            <mat-error
              *ngIf="
                imSysForm.controls.technicalData.controls.uploads.touched &&
                imSysForm.controls.technicalData.controls.uploads.errors?.required
              ">
              Bitte laden Sie mindestens ein Dokument hoch
            </mat-error>
            <form-row
              *ngIf="!isFieldHidden(powerConfig.externalImsysInstallationMobileConnectionStrengthField)">
              <mat-form-field appearance="outline" fxFlex="90">
                <mat-label>Mobilfunk-Empfang (Signalstärke)</mat-label>
                <mat-select
                  [formControl]="imSysForm.controls.technicalData.controls.mobileConnectionStrength">
                  <mat-option *ngFor="let option of mobileConnectionStrengthOptions" [value]="option">
                    {{ MobileConnectionStrengthDisplayNames[option] }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    imSysForm.controls.technicalData.controls.mobileConnectionStrength.touched &&
                    imSysForm.controls.technicalData.controls.mobileConnectionStrength.errors?.required
                  ">
                  Bitte geben Sie eine Signalstärke an
                </mat-error>
              </mat-form-field>
              <app-tooltip-icon
                info="Für das intelligente Messsystem wird ein ausreichender Mobilfunk-Empfang benötigt. Bitte testen Sie am Installationsort die Signalstärke mit Ihrem Handy und geben diese im Auswahlfeld an"
                placement="top"></app-tooltip-icon>
            </form-row>
            <app-user-decision-radio-buttons
              *ngIf="!isFieldHidden(powerConfig.externalImsysInstallationIsFeederPresentField)"
              [control]="imSysForm.controls.technicalData.controls.isFeederPresent"
              [label]="
                'Besteht an Ihrem Netzanschluss bereits eine Einspeisung (z.B. durch eine Photovoltaikanlage)?' +
                (isFieldRequired(powerConfig.externalImsysInstallationIsFeederPresentField) ? '*' : '')
              " />
            <ng-container
              *ngIf="isUserDecisionYes$(imSysForm.controls.technicalData.controls.isFeederPresent) | async">
              <form-row *ngIf="!isFieldHidden(powerConfig.externalImsysInstallationFeederTypeField)">
                <mat-form-field appearance="outline" fxFlex="95">
                  <mat-label>
                    {{
                      'Art der Einspeiseanlage' +
                        (isFieldRequired(powerConfig.externalImsysInstallationFeederTypeField) ? '*' : '')
                    }}
                  </mat-label>
                  <input
                    matInput
                    type="text"
                    maxlength="90"
                    [formControl]="imSysForm.controls.technicalData.controls.feederType" />
                  <mat-error
                    *ngIf="
                      imSysForm.controls.technicalData.controls.feederType.touched &&
                      imSysForm.controls.technicalData.controls.feederType.errors?.required
                    ">
                    Bitte geben Sie an, um welche Art von Einspeiseanlage es sich handelt
                  </mat-error>
                </mat-form-field>
              </form-row>
            </ng-container>
            <app-user-decision-radio-buttons
              *ngIf="!isFieldHidden(powerConfig.externalImsysInstallationIsConsumerPresentField)"
              [control]="imSysForm.controls.technicalData.controls.isConsumerPresent"
              [label]="
                'Gibt es am Netzanschluss eine steuerbare Verbrauchseinrichtung gemäß §14a EnWG (Wärmepumpe, Klimaanlage, Wallbox, Batteriespeicher) mit einer Leistung über 4,2 kW?' +
                (isFieldRequired(powerConfig.externalImsysInstallationIsConsumerPresentField) ? '*' : '')
              " />
            <ng-container
              *ngIf="isUserDecisionYes$(imSysForm.controls.technicalData.controls.isConsumerPresent) | async">
              <form-row *ngIf="!isFieldHidden(powerConfig.externalImsysInstallationConsumerTypeField)">
                <mat-form-field appearance="outline" fxFlex="95">
                  <mat-label>
                    {{
                      'Art der Anlage gemäß §14a EnWG' +
                        (isFieldRequired(powerConfig.externalImsysInstallationConsumerTypeField) ? '*' : '')
                    }}
                  </mat-label>
                  <input
                    matInput
                    type="text"
                    maxlength="90"
                    [formControl]="imSysForm.controls.technicalData.controls.consumerType" />
                  <mat-error
                    *ngIf="
                      imSysForm.controls.technicalData.controls.consumerType.touched &&
                      imSysForm.controls.technicalData.controls.consumerType.errors?.required
                    ">
                    Bitte geben Sie an, welche Anlage Sie gemäß §14a EnWG nutzen
                  </mat-error>
                </mat-form-field>
              </form-row>
            </ng-container>
            <app-user-decision-radio-buttons
              *ngIf="!isFieldHidden(powerConfig.externalImsysInstallationIsAnnualConsumptionExceededField)"
              [control]="imSysForm.controls.technicalData.controls.isAnnualConsumptionExceeded"
              [label]="
                'Lag der durchschnittliche jährliche Stromverbrauch am Netzanschluss während der letzten drei Jahre bei mehr als 6.000 kWh?' +
                (isFieldRequired(powerConfig.externalImsysInstallationIsAnnualConsumptionExceededField)
                  ? '*'
                  : '')
              " />
            <app-external-privacy-form-field [control]="imSysForm.controls.acceptConditions" />
            <ng-container
              *ngIf="
                imSysForm.controls.acceptPricingTable && 'commissioning.external.pricingTableConditions'
                  | uiAdaptionVisible
              ">
              <form-row>
                <mat-checkbox [formControl]="imSysForm.controls.acceptPricingTable">
                  <div [innerHTML]="'commissioning.external.pricingTableConditions' | uiAdaptionValue"></div>
                  <mat-error
                    *ngIf="
                      imSysForm.controls.acceptPricingTable?.invalid &&
                      imSysForm.controls.acceptPricingTable?.touched
                    ">
                    Bitte akzeptieren Sie die Bedingungen für das Preisblatt
                  </mat-error>
                </mat-checkbox>
              </form-row>
            </ng-container>
          </section>

          <section>
            <form-row>
              <div
                class="button-container"
                fxLayout="row"
                fxLayoutAlign="space-between center"
                fxLayoutGap="20px"
                fxFlex>
                <app-custom-button
                  [title]="'Installation beantragen'"
                  (onClick)="onConfirm(imSysForm)"></app-custom-button>
              </div>
            </form-row>
          </section>
        </mat-step>
      </mat-vertical-stepper>
    </form>
  </div>

  <ng-template #loading>
    <app-loading-overlay></app-loading-overlay>
  </ng-template>
</div>
